import React, { useRef, useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import lunch_box from '../../../../images/product/meals_box.png';
import Select from "react-select";
import axios from "axios";

const Renewal_Remainder = ({ show, onClose }) => {

    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const [datas, setData] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);

    const [selecFilter, setSelFilter] = useState(7);

    // page table data fetch
    const fetchData = () => {
        const params = {
            branch_id,
            filter: selecFilter
        }
        axios.get(`${baseURL}/subscription/reminder`, { params: params })
            .then(response => {
                setData(response.data.data);
                setHasFetched(true);
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
                setHasFetched(true);
            });
    };

    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };

    const tableRef = useRef(null);
    useEffect(() => {
        if (hasFetched) {
            if (tableRef.current) {
                if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                    $(tableRef.current).DataTable({
                        "responsive": true,
                        //   "aaSorting": [],
                        "ordering": false,
                        paging: false,
                        scrollY: "500px", // Set the scroll height here
                        scrollCollapse: true,
                        "language": {
                            "lengthMenu": "Show _MENU_",
                        },
                        "dom":
                            "<'row'" +
                            // "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                            "<'col-sm-12 d-flex align-items-center justify-content-end mb-2'f>" +
                            ">" +
                            "<'table-responsive'tr>" +
                            "<'row'" +
                            "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                            // "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                            ">"
                    });
                }
            }
        }
    }, [hasFetched]);

    // fetch data
    useEffect(() => {
        setHasFetched(false);
        if ($.fn.dataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }
        fetchData();
    }, [selecFilter]);

    // format date display
    const formatDate = (date) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    function capitalizeFirstLetter(str) {
        if (!str) return '';
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    const filter = [
        { value: 7, label: '7 Days' },
        { value: 5, label: '5 Days' },
        { value: 3, label: '3 Days' },
        { value: 2, label: '2 Days' },
        { value: 1, label: '1 Days' },
    ];

    return (
        <Modal show={show} size="xl"  >
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Renewal Remainder</h3>
                    <Button variant="" type="button" className="close px-6 py-1" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">

                    <div className='col-lg-3'>
                        <Select placeholder="Select Filter Days"
                            options={filter}
                            defaultValue={filter[0]}
                            onChange={(e) => setSelFilter(e.value)}
                        />
                    </div>

                    <div className="table-container">


                        <table ref={tableRef} id="kt_datatable_responsive_approved" className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                            <thead>
                                <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                    <th className='text-start'>Subscribers</th>
                                    <th className='text-start'>Products</th>
                                    <th className='text-start'>Area / Delivery Point</th>
                                    <th className='text-end'>Amount</th>
                                    <th className='text-start'>End Date</th>
                                </tr>
                            </thead>
                            <tbody className="text-gray-600 fw-semibold fs-7">
                                {datas.map((data, index) => (
                                    <tr key={data.sno}>
                                        <td className='text-start'>
                                            <label className='text-black font-w400 fs-7'>{capitalizeFirstLetter(data.lead_name)}</label>
                                            <div className='d-block'>
                                                <label className='text-gray-600 fs-8'>{data.lead_mobile_no}</label>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="d-flex align-items-center justify-content-start gap-2">
                                                <LightGallery
                                                    onInit={onInit}
                                                    speed={500}
                                                    plugins={[lgThumbnail, lgZoom]}
                                                >
                                                    <div data-src={data.package_image || lunch_box} className='border rounded px-1 py-0'>
                                                        <img src={data.package_image || lunch_box} alt={data.product_name} className='cursor-pointer w-45px h-45px' />
                                                    </div>
                                                </LightGallery>
                                                <div className='mb-0'>
                                                    <label className='text-black font-w400 fs-7'>{data.product_name}</label>
                                                    <div className="d-block">
                                                        <div className="fs-8 font-w600 text-dark">{data.timeline_name} ({data.timeline_days} Days)</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <td className='text-start'>
                                            <label className='text-black font-w400 fs-7'>{data.area_name}</label>
                                            <div className='d-block'>
                                                <label className='text-gray-600 fs-8'>{data.delivery_point_name}</label>
                                            </div>
                                        </td>
                                        <td align='right'>
                                            <label className='text-danger font-w600  fs-7 py-0 px-1'>
                                                <span><i class="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                                <span>{new Intl.NumberFormat('en-IN').format(data.amount)}</span>
                                            </label>
                                        </td>
                                        <td className='text-start'>
                                            <label className='text-black font-w400 fs-7'>{formatDate(data.end_date)}</label>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        

                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default Renewal_Remainder;
